// extracted by mini-css-extract-plugin
module.exports = {"timePeriodButton":"TimePeriodButton_timePeriodButton__WyMCX","selected":"TimePeriodButton_selected__2KB7Q"};